export class Accordion {
    buttonEl: HTMLElement;
    contentEl: HTMLElement;
    isOpen: boolean;
    static init() {
        // init accordions
        const accordions = document.querySelectorAll(".accordion button");
        [].forEach.call(accordions, (accordionEl: HTMLElement) => {
            new Accordion(accordionEl);
        });
    }
    constructor(domNode: HTMLElement) {
        this.buttonEl = domNode;
        const controlsId = this.buttonEl.getAttribute("aria-controls");
        if (controlsId != null) {
            this.contentEl = document.getElementById(controlsId);
            this.isOpen = this.buttonEl.getAttribute("aria-expanded") === "true";
            // add event listeners
            this.buttonEl.addEventListener("click", this.onButtonClick.bind(this));
        }
    }

    onButtonClick() {
        this.toggle(!this.isOpen);
    }

    toggle(isOpen: boolean) {
        // don't do anything if the open state doesn't change
        if (isOpen === this.isOpen) {
            return;
        }

        // update the internal state
        this.isOpen = isOpen;

        // handle DOM updates
        this.buttonEl.setAttribute("aria-expanded", `${isOpen}`);
        if (isOpen) {
            this.contentEl.removeAttribute("hidden");
        } else {
            this.contentEl.setAttribute("hidden", "");
        }
    }

    // Add public open and close methods for convenience
    open() {
        this.toggle(true);
    }

    close() {
        this.toggle(false);
    }
}
